<template>
  <div>
    <v-card>
      <v-flex xs12>
        <form>
          <v-expansion-panel expand :value="[true]">
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.proposalNo" :label="labels.proposalNo" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="labels.proposalNo" v-validate="'max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete :items="productList" v-model="filters.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.status" :error-messages="errors.collect('product')"></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete :items="planList" v-model="filters.plan" :label="labels.plan" item-text="label" item-value="value" data-vv-name="plan" :data-vv-as="labels.plan" :error-messages="errors.collect('plan')"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete :items="booleanList" v-model="filters.paid" :label="labels.paid" item-text="label" item-value="value" data-vv-name="paid" :data-vv-as="labels.paid" :error-messages="errors.collect('paid')"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </form>
      </v-flex>
      <v-divider></v-divider>
      <v-card-title>
        <div class="headline">{{appDesc(appID)}} Transaction Listing</div>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.product }}</td>
          <td class="text-xs-left">{{ props.item.plan }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.paid) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" query @query="doQuery(props.item)" :loading="query"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { globalMixin } from './globalMixin'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      headers: [
        { text: 'Proposal No.', value: 'id' },
        { text: 'Product', value: 'product' },
        { text: 'Plan', value: 'plan' },
        { text: 'Paid Status', value: 'paid' },
        TableConst.tableActionHeader
      ],
      labels: {
        proposalNo: 'Proposal No.',
        product: 'Product',
        plan: 'Plan',
        paid: 'Paid'
      },
      filters: {
        usrId: this.id,
        proposalNo: null,
        product: null,
        plan: null,
        paid: null
      },
      totalItems: 0,
      query: false,
      productList: [],
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      planList: []
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending'(value) {
      this.doFetch(false)
    },
    'pagination.page'(value) {
      this.doFetch(false)
    },
    'pagination.rowsPerPage'(value) {
      this.doFetch(false)
    },
    'pagination.sortBy'(value) {
      this.doFetch(false)
    }
  },
  mounted() {
    this.doFetch(true)
  },
  methods: {
    async doFetch(options) {
      let apiURI = null
      if (this.appID === 'FI') {
        apiURI = this.memberMenu.fireProposals
      } else if (this.appID === 'MD') {
        apiURI = this.memberMenu.maidProposals
      } else if (this.appID === 'TR') {
        apiURI = this.memberMenu.travelProposals
      }
      if (apiURI) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            usrId: this.id,
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          this.items = []
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (options) {
              this.productList = result.data.products
              this.planList = result.data.plans
            }
            if (data) {
              data.map(quote => {
                const convertList = {
                  id: quote.quoteInfo.proposalNo,
                  product: quote.quoteInfo.product,
                  plan: quote.quoteInfo.plan,
                  paid: quote.quoteInfo.paid,
                  premiumPaid: quote.quoteInfo.premium,
                  insuredInfo: quote.insuredInfo,
                  quoteInfo: quote.quoteInfo
                }
                this.items.push(convertList)
              })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    async doQuery(data) {
      if (data) {
        if (this.$route.path.includes('review')) {
          this.query = true
          this.$store.commit('TRANSLINK', data)
          let misc = false
          let miscText = null
          let redirect = null
          if (this.appID === 'TR') {
            misc = true
            miscText = 'Insured'
            redirect = { name: 'travelTrans' }
          } else if (this.appID === 'FI') {
            misc = false
            miscText = ''
            redirect = { name: 'fireTrans' }
          } else if (this.appID === 'MD') {
            misc = true
            miscText = 'Domestic Worker'
            redirect = { name: 'maidTrans' }
          }
          const commitData = {
            tabMenu: 1,
            displayReviewTab: true
          }
          const commitMisc = {
            misc, miscText
          }
          this.$store.commit('TABMENU', commitData)
          this.$store.commit('MISCTAB', commitMisc)
          this.$router.push(redirect)
          this.query = false
        } else {
          this.query = true
          this.$store.commit('TRANSLINK', data)
          let misc = false
          let miscText = null
          let redirect = null
          if (this.appID === 'TR') {
            misc = true
            miscText = 'Insured'
            redirect = { name: 'travelTransQuery' }
          } else if (this.appID === 'FI') {
            misc = false
            miscText = ''
            redirect = { name: 'fireTransQuery' }
          } else if (this.appID === 'MD') {
            misc = true
            miscText = 'Domestic Worker'
            redirect = { name: 'maidTransQuery' }
          }
          const commitData = {
            tabMenu: 1,
            displayReviewTab: true
          }
          const commitMisc = {
            misc, miscText
          }
          this.$store.commit('TABMENU', commitData)
          this.$store.commit('MISCTAB', commitMisc)
          this.$router.push(redirect)
          this.query = false
        }
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doFetch(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.id = null
      this.filters.product = null
      this.filters.plan = null
      this.filters.status = null
      this.doFetch(false)
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    memberMenu() {
      return this.$store.state.adminMember.menu
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    globalMixin
  ],
  props: ['appID', 'id', 'memberQuery']
}
</script>

<style>
</style>
